import { schema } from 'normalizr';

const domain = new schema.Entity( 'senderDomainPair', {
}, {
    idAttribute: ( value ) => value.domain,
} );
const sender = new schema.Entity( 'senderDomainPair', {
}, {
    idAttribute: ( value ) => value.senderId,
} );

export const domainsBySenderSchema = [ sender ];
export const sendersByDomainSchema = [ domain ];
